import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { TableRow, TableCell, ActionSelect, LiNotSelectedAction, DropdownActionPlaceholder, DropdownULAction, ChevronDownWrapper, ButtonWrapper, ListedTitles } from './PEPRequests.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { useClickOutside } from 'src/utils/hooks/useClickOutside';
import { PEPState } from 'src/components/FraudAndCompliance/PEPTab/PEPState';
import { notificationCountsItems } from 'src_server/types';
import { DateTime } from 'src_common/utils/time/time';

type TListPepAndSanctionsElement = notificationCountsItems.TSuccessResponse extends Array<infer Data> ? Data : never;

interface PEPRequestsRowPropsType {
    PEPElement: TListPepAndSanctionsElement,
    PEPState: PEPState,
}

const renderTitles = (titleArray: string[]): React.ReactElement => {
    return (<ListedTitles>
        {titleArray.map(
            (title: string, index: number) => <li key={index}> - {title}{index === titleArray.length - 1 ? null : ','}</li>
        )}
    </ListedTitles>);
};

export const PEPRequestsRow = observer('PEPRequestsRow', (props: PEPRequestsRowPropsType): React.ReactElement | null => {
    const [particularAction, setParticularAction] = useState(false);
    const { PEPElement, PEPState } = props;

    const handleParticularAction = (clickOutside: boolean): void => {

        if (clickOutside === true) {
            setParticularAction(false);
        }
    };

    const [setParticularActionRef] = useClickOutside({ callback: handleParticularAction });
    const appState = useAppStateContext();

    const onClick = (): void => {
        appState.reduxAction.customersActionsOpenRequest(PEPElement.accountId);
    };

    return (
        <TableRow section={'other'} data-test={`pep-requests-row-${PEPElement.accountId}`}>
            <TableCell isClickable={false} cellWidth={10} data-test='pep-requests-account-id'>
                {PEPElement.accountId}
            </TableCell>
            <TableCell isClickable={false} cellWidth={15} data-test='pep-requests-date'>
                {DateTime.from(PEPElement.createdAt)?.format('DD/MM/YYYY HH:mm')}
            </TableCell>
            <TableCell isClickable={true} onClick={onClick} cellWidth={15} data-test='pep-requests-full-name'>
                {PEPElement.accountName}
            </TableCell>
            <TableCell isClickable={false} cellWidth={15} data-test='pep-requests-pep-titles'>
                {renderTitles(PEPElement.details.titlesOfPEPs ?? [])}
            </TableCell>
            <TableCell isClickable={false} cellWidth={15} data-test='pep-requests-sanction-titles'>
                {renderTitles(PEPElement.details.titlesOfSanctions ?? [])}
            </TableCell>
            <TableCell onClick={(): void => {
                setParticularAction(!particularAction);
            }} isClickable={false} cellWidth={15}>
                <ActionSelect ref={setParticularActionRef}>
                    <DropdownActionPlaceholder data-test='pep-requests-reviewed-select'>
                        {'Select'}
                        <ChevronDownWrapper />
                    </DropdownActionPlaceholder >
                    {particularAction ?
                        <DropdownULAction>
                            <LiNotSelectedAction onClick={(): Promise<void> => PEPState.handleCheckOne(PEPElement.id, PEPElement.accountId)} data-test='pep-requests-mark-as-reviewed-option'>{'Mark As Reviewed'}</LiNotSelectedAction>
                        </DropdownULAction> : null
                    }
                </ActionSelect>
            </TableCell>
            <TableCell isClickable={false} cellWidth={15}>
                <ButtonWrapper
                    version='primary' size='small' width='full'
                    onClick={() => PEPState.toggleModal(PEPElement.accountId, true)}
                    dataTest='pep-requests-xml-button'
                >XML
                </ButtonWrapper>

            </TableCell>
        </TableRow>
    );
});
